import { gql } from "urql";
export const CaseManagerDrawerQuery = gql `
    query CaseManagerDrawer($organizationId: String) {
        locations {
            locationsList(organizationId: $organizationId) {
                value
                label
            }
        }
    }
`;
export const OrganizationAdminDrawerQuery = gql `
    query OrganizationAdminDrawer($organizationId: String) {
        locations {
            locationsList(organizationId: $organizationId) {
                value
                label
            }
        }
    }
`;
export const OrganizationDrawerQuery = gql `
    query OrganizationDrawer($organizationId: String) {
        organizations {
            organization(organizationId: $organizationId) {
                organizationId
                npiNumber
                name
                phoneNumber
                email
                about
                notes
                organizationTypes
                websiteUrl
                createdAt
                isActive
                insuranceIds
                therapyCategoryIds
                imageUrl
            }
        }
    }
`;
export const OrganizationEntityListQuery = gql `
    query OrganizationEntityList {
        insurances {
            insurancesList {
                value
                label
            }
        }
        therapyCategories {
            therapyCategoriesList {
                value
                label
            }
        }
    }
`;
export const PatientDrawerQuery = gql `
    query PatientDrawer($patientId: String!) {
        patients {
            patient(patientId: $patientId) {
                patientId
                caregiverId
                firstName
                lastName
                postalCode
                dateOfBirth
                preferredLanguages
                gradeLevel
                daysAvailable
                timeAvailable
                providers {
                    userId
                }
                insuranceList {
                    value
                    label
                }
                conditionList {
                    value
                    label
                }
                therapyCategoryList {
                    value
                    label
                }
                therapySubCategoryList {
                    value
                    label
                }
            }
        }
    }
`;
export const EntityListQuery = gql `
    query EntityList {
        users {
            users(roleNames: [Provider]) {
                userId
                firstName
                lastName
                imageUrl
            }
        }
        conditions {
            conditionsList {
                value
                label
            }
        }
        insurances {
            insurancesList {
                value
                label
            }
        }
        therapyCategories {
            therapyCategoriesList {
                value
                label
            }
        }
    }
`;
export const PriorityEntryModalQuery = gql `
    query PriorityEntryModal($inOrganization: Boolean) {
        users {
            users(roleNames: [Provider]) {
                userId
                firstName
                lastName
                imageUrl
            }
        }
        priorityStatuses {
            priorityStatuses {
                priorityStatusId
                name
                colorHex
                sortOrder
                isMutable
                simpleEmailTemplateId
            }
        }
        conditions {
            conditionsList {
                value
                label
            }
        }
        insurances {
            insurancesList {
                value
                label
            }
        }
        therapyCategories {
            therapyCategoriesList(inOrganization: $inOrganization) {
                value
                label
            }
        }
    }
`;
export const ProviderDrawerQuery = gql `
    query ProviderDrawer($inOrganization: Boolean, $organizationId: String) {
        locations {
            locationsList(organizationId: $organizationId) {
                value
                label
            }
        }
        therapyCategories {
            therapyCategoriesList(
                inOrganization: $inOrganization
                organizationId: $organizationId
            ) {
                value
                label
            }
        }
    }
`;
